import { useIntl } from 'react-intl'
import type { AgentHubBookingOnboardingStepId } from './agentHubBookingOnboardingSteps'

export function useAgentHubBookingOnboardingCopy(): Record<AgentHubBookingOnboardingStepId, {
  body: string
  title: string
}> {
  const intl = useIntl()

  return {
    welcome: {
      title: intl.formatMessage({
        id: '_YQfcWCjR3uquGQ_w0ty',
        defaultMessage: 'Welcome to LE Agent Hub!',
        description: 'Title for the first Agent Hub booking platform onboarding welcome step',
      }),
      body: intl.formatMessage({
        id: 'GzTWUs6Q4wg-yESQVtfx',
        defaultMessage: 'This is the booking platform, where you can make all the bookings for your customers.',
        description: 'Welcome body explaining that the customer site is the Agent Hub booking platform',
      }),
    },
    products: {
      title: intl.formatMessage({
        id: 'ldIsrn8OFn9qTkWzLJaI',
        defaultMessage: 'Navigation bar',
        description: 'Title for the Agent Hub booking platform onboarding product navigation step',
      }),
      body: intl.formatMessage({
        id: 'twwdypmUxgrUk-bSe1fV',
        defaultMessage: 'Use this navigation bar to find the product you want to sell to your customers.',
        description: 'Onboarding body highlighting the product navigation bar for Agent Hub agents',
      }),
    },
    search: {
      title: intl.formatMessage({
        id: 'Rz4Fdz7y-rX8e02YBRMO',
        defaultMessage: 'Search',
        description: 'Title for the Agent Hub booking platform onboarding destination search step',
      }),
      body: intl.formatMessage({
        id: 's9RMKHQVkWoCFQnhTDr-',
        defaultMessage: 'Simply search for your preferred destination to see the best deals Agent Hub has to offer.',
        description: 'Onboarding body highlighting the header search bar for Agent Hub destination search',
      }),
    },
    'customer-view': {
      title: intl.formatMessage({
        id: 'QJyOvY8Dj3vRfy8zP82O',
        defaultMessage: 'Customer view',
        description: 'Title for the Agent Hub booking platform onboarding customer view toggle step',
      }),
      body: intl.formatMessage({
        id: 'KHdo7P0MOg4pOOV_zo9e',
        defaultMessage: 'Click here to hide your commission so you can show your customers your screen.',
        description: 'Onboarding body highlighting the customer view switch that hides agent commission',
      }),
    },
    account: {
      title: intl.formatMessage({
        id: 'dFgebGJVkueDj1df7rrC',
        defaultMessage: 'Your account',
        description: 'Title for the Agent Hub booking platform onboarding account menu step',
      }),
      body: intl.formatMessage({
        id: 'Xr1h3hwPbmmZsw8ESe1T',
        defaultMessage: 'Click here to navigate to your Agent Portal.',
        description: 'Onboarding body highlighting the account menu used to return to the Agent portal',
      }),
    },
  }
}
